Service = App.loadClass 'core::Angular/Service'
jenks = require('node_modules/turf-jenks')

class exports.LegendService extends Service
    constructor: (@rootScope) ->
        # hold data for multiple layers at a time
        @stack = {}
        # used for coloring geojson feature collections
        @bin_colors = []
        # redirects geojson layer processing from its legacy handler
        @geojson_layer_rule = 'skip'
        # actual colors that will be mapped using colors by breaks
        @colors = {
            dark_green: '#00FF00'
            green: '#7FFF00'
            yellow: '#FFFF00'
            orange: '#FF7F00'
            red: '#FF0000'
        }
        # a list of the color combinations that we will use based on the number of breaks
        @colors_by_breaks = {
            1: ['dark_green']
            2: ['dark_green', 'red']
            3: ['dark_green', 'yellow', 'red']
            4: ['dark_green', 'yellow', 'orange', 'red']
            5: ['dark_green', 'green', 'yellow', 'orange', 'red']
        }

    formatNumber: (number) ->
        # translate 35400 -> 35.4 , 35000 -> 35.0
        return (number / 1000).toPrecision(3)

    calculateColorsByBreaks: () ->
        # determine which colors to use based on the break count
        @current_colors = @colors_by_breaks[if @break_count <= 5 then @break_count else @break_count - 1;]

    generateBinningColors: () ->
        # reset bin colors
        @bin_colors = []
        # generate color bins
        for bin, i in @bins
            @bin_colors.push [bin[0], bin[1], @colors[@current_colors[i]]]

    calculateColors: (attr = 'fillColor') ->
        # reclass for binning
        return @reclass(@geojson, @property, attr, @bin_colors)

    reclass: (geojson, property, mapTo, values) =>
        for feature in geojson.features
            for bin in values
                if feature.properties[property] >= bin[0] and feature.properties[property] <= bin[1]
                    feature.properties[mapTo] = bin[2]

        return geojson

    unique: (value, index, self) ->
        # filter unique values callback
        return self.indexOf(value) is index

    prepareDataForBreaks: () =>
        # reset values
        @values = []

        for feature in @geojson.features
            feature.properties[@property] = Number feature.properties[@property]
            @values.push feature.properties[@property]

        @calculateBreakCount()

    update: (@geojson, @property = 'population', @max_breaks = 5) ->
        # ensure that needed values are numeric
        @prepareDataForBreaks()
        # calculate break points using break count
        @calculateBreaks()
        # decide which colors will be used based on breaks
        @calculateColorsByBreaks()
        # calculate ranges
        @calculateRanges()
        # generate color bins
        @generateBinningColors()
        # finish coloring
        return @calculateColors()

    calculateBreakCount: () ->
        # get the breaks from array of values
        @number_of_unique_values = @values.filter(@unique).length
        # determine the break count based on the number of unique values
        @break_count = if @number_of_unique_values >= @max_breaks then @max_breaks else @number_of_unique_values

    calculateCustomBreakCount: () =>
        # ensure that we pick a valid count based on the available values
        if @number_of_unique_values > @max_breaks
            return Math.ceil(@max_breaks / 2)
        else
            return Math.floor(@number_of_unique_values / 2)

    generateCustomBreaks: () =>
        @breaks = []
        values = @values.filter(@unique)
        # generate breaks that will include all values
        for i in [0...@calculateCustomBreakCount()]
            @breaks.push values[i]
            @breaks.push values[values.length - 1 - i]

        # we need to sort the breaks before we generate ranges
        @breaks.sort((a, b) ->
            return a - b
        )

        # update the break count
        @break_count = @breaks.length

    tryForMoreBreaks: () =>
        breaks = []
        # Attempt to get a better solution if possible
        for i in [@max_breaks...@number_of_unique_values]
            try
                breaks = jenks(@geojson, @property, i)
            catch e
                # The natural breaks algorithm will crash if a solution is not possible
                break

            # see if we were able to get an acceptable solution
            if breaks.filter(@unique).length > @max_breaks
                # update the break count and breaks before break from the loop
                @break_count = i
                @breaks = breaks
                break

        # if an optimal natural breaks solution is not possible, we will have to generate the ranges manually
        if @breaks.filter(@unique).length <= @max_breaks
            @generateCustomBreaks()

    calculateBreaks: () =>
        # calculate breaks based on values and break count
        @breaks = jenks(@geojson, @property, @break_count)

        # determine if we need to re-calculate break count for edge cases
        if @break_count >= @max_breaks
            # ensure that we have the values needed
            if @number_of_unique_values > @breaks.filter(@unique).length
                # try to get a better natural breaks solution
                @tryForMoreBreaks()

    generateRangeBreaks: () ->
        breaks = []

        # bind values by ranges rather than binding ranges by values
        for i in [0...@distinct_values.length]
            if i in [0, @distinct_values.length - 1]
                breaks.push @distinct_values[i]
            else
                breaks.push (@distinct_values[i] + @distinct_values[i + 1]) / 2

        # update variables
        @breaks = breaks
        @distinct_values = @breaks.filter(@unique)

    calculateRanges: () ->
        # reset ranges
        @bins = []
        # get distinct values
        @distinct_values = @breaks.filter(@unique)
        # loop and build ranges
        if @useValueInsteadOfRange()
            for i in [@distinct_values.length...0]
                @bins.push [@distinct_values[i - 1], @distinct_values[i - 1], "#{i+1}"]
        else
            # use breaks to generate range breaks
            @generateRangeBreaks()

            for i in [@max_breaks...0]
                @bins.push [@distinct_values[i - 1], @distinct_values[i], "#{i+1}"]

    constructRows: () ->
        rows = []
        # rows will either be constructed as values or ranges
        if @useValueInsteadOfRange()
            for bin in @bin_colors
                rows.push { range: "#{@formatNumber(bin[0])}", style: 'background-color': "#{bin[2]}" }
        else
            for bin in @bin_colors
                rows.push {
                    range: "#{@formatNumber(bin[0])}-#{@formatNumber(bin[1])}",
                    style: 'background-color': "#{bin[2]}"
                }

        return rows

    updateMapProperties: (geojson, desired_copy = 'fillColor') ->
        # copy from properties to mapProperties to comply with rx map styling format
        for f in geojson.features when f.properties[desired_copy]?
            f.mapProperties[desired_copy] = f.properties[desired_copy]

        return geojson

    useValueInsteadOfRange: () ->
        # determine whether each classification should be represented by a range or single value
        return @break_count < @max_breaks or @distinct_values?.length <= @max_breaks

    getHTML: () ->
        # get HTML from angular view (usually after its been updated)
        return angular.element('#legend')[0].innerHTML

    cacheHTML: () ->
        # store the current HTML as a reference in case it changes
        @html = @getHTML()

    removeLegend: () ->
        # remove the previously added legend by using the HTML that it was created from
        App.map.legendControl.removeLegend @html

    addLegend: () ->
        # add a new legend by HTML string
        App.map.legendControl.addLegend @html

    updateLegend: () ->
        # remove old legend if needed
        @removeLegend() if @html
        # update cached HTML for the new legend
        @cacheHTML()
        # add the new legend to the map
        @addLegend()

    geojsonLayerHandlerProcessingRedirect: (handler, layer_name, layer_id) ->
        # take care of processing for a geojson layer
        handler.beforeProcess = (response, geojson) =>
            @processGeojsonLayer(geojson, handler, layer_name, layer_id)
            return @geojson_layer_rule

    processGeojsonLayer: (geojson, handler, layer_name, layer_id) ->
        # process the new geojson
        @update(geojson)
        # update map properties
        @geojson = @updateMapProperties(@geojson)
        # apply styling
        handler.applyLayerStyling(@geojson)
        # generate name
        name = @generateStackName(layer_name, layer_id)
        # add a custom callback for cleanup
        handler.callback = () =>
            @cleanup()
            @checkStack(name, true)
            @broadcast('stack-ready') if @getPreviousStack()
        # show the layer
        handler.showLayer()
        # ensure opacity is set
        handler.setOpacity handler.defaultOpacity
        # let angular controllers know to update rows
        @broadcast('update-rows')
        # push layer onto the stack
        @appendStack(name, @constructRows())

    appendStack: (name, data) ->
        # add an object to the stack for the current geojson layer
        @stack[name] = data

    checkStack: (name, del = false) ->
        # used to either remove an object, or check for and return one by name
        if del and @stack[name]?
            @deleteFromStack(name)
            return true
        else if @stack[name]?
            return @stack[name]

        # the stack doesn't contain an object for the given name
        return false

    deleteFromStack: (name) ->
        delete @stack[name]

    getPreviousStack: () ->
        # get the previous object from all active handlers
        # returns previous object, or undefined if none exist
        return @stack[Object.keys(@stack).slice(-1).pop()]

    comparePreviousStackValues: (a) ->
        # compare stack objects by value
        return _.isEqual(a, @getPreviousStack())

    generateStackName: (layer_name, layer_id) ->
        # generate unique identifier
        return "#{layer_name}#{layer_id}"

    broadcast: (message) ->
        @rootScope.$broadcast("legend:#{message}")

    cleanup: () ->
        @bins = []
        @bin_colors = []
        @breaks = []
        @geojson = null
        @property = ''
        @removeLegend() if @html?
        @html = ''
